/**
 * Project : workspace
 * File    : SelectUOMRow.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.inventory.component

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.inventory.viewModel.uom.UOMViewModel
import com.parmartechnologies.core.feature.inventory.uom.model.UOM
import component.text.TextLink
import component.text.TextTitle
import navigation.AppNavigator
import navigation.route.inventory.InventoryNavRoute
import theme.ThemeColor

@Composable
/**
 * Executes the select u o m row operation.
 *
 * @receiver TODO
 * @param selected The selected.
 * @param onChange The on change.
 * @return Unit – no return value.
 */
fun SelectUOMRow(selected: String?, onChange: (UOM) -> Unit = {}) {
    val businessViewModel = BusinessViewModel()
    val myBusiness = businessViewModel.myBusiness.collectAsState()
    val viewModel = UOMViewModel(myBusiness.value)
    val allUOM = viewModel.allUOM.collectAsState()
    
    LaunchedEffect(key1 = Unit) {
        viewModel.loadAllUOM()
    }
    Column(
        modifier = Modifier.fillMaxWidth().height(90.dp)
            .background(ThemeColor.shared().defaultBakground)
    ) {
        Row(
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            TextTitle("UOM")
            Spacer(Modifier.weight(1f))
            TextLink("UOMs"){
                AppNavigator.shared().navigate(InventoryNavRoute.UOM.LIST)
            }
        }
        Spacer(modifier = Modifier.height(4.dp))
        LazyRow(
            modifier = Modifier.fillMaxWidth().height(50.dp)
                .background(ThemeColor.shared().defaultBakground)
        ) {
            items(allUOM.value.count()) {
                HorizontalUOMCard(
                    allUOM.value[it],
                    isSelected = selected == allUOM.value[it]._id
                ) {
                    onChange(it)
                }
            }
        }
    }

}